import React from 'react';
import { useAppSelector } from 'hooks';

import { AuthTags } from '~constants/authTags';

import { Modal, TabContainer } from '~components';
import { AccessSettings } from '~support-at-home/components/common';

import { selectAuthenticatedUser } from '~main/selectors/login';

interface ComponentProps {
  setIsOpen: (val: boolean) => void;
  isOpen: boolean;
}

const CustomFormsAccessSettings: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  const user = useAppSelector(selectAuthenticatedUser);
  return (
    <AccessSettings
      isActive={isActive}
      module="forms"
      name="customforms"
      adminTag={AuthTags.FORMS.CUSTOMFORMS.CREATE}
      explicitOnly={['Create']}
      unlockOnly={['Create']}
      permissionLabels={{ View: 'View/Fill' }}
      canManage={Boolean(user?.unlocking_permissions)}
    />
  );
};

const CustomFormsSettingsModal: React.FC<ComponentProps> = ({ setIsOpen, isOpen }) => {
  const tabs = [{ id: 'forms-access-settings', title: 'Access Settings', component: CustomFormsAccessSettings }];

  return (
    <Modal
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      size="xl"
      headerClassName="header"
      header="Custom Forms Settings"
      className="custom-forms-settings feature"
      data-cy="custom-forms-settings-modal"
    >
      <TabContainer tabs={tabs} />
    </Modal>
  );
};

export default CustomFormsSettingsModal;
